import React from 'react';
import { BookOpen, Users, Award, Clock } from 'lucide-react';

const features = [
  {
    icon: BookOpen,
    title: 'Expert-Led Courses',
    description: 'Learn from industry experts with real-world SAP S4HANA experience',
  },
  {
    icon: Users,
    title: 'Small Batch Size',
    description: 'Personal attention with maximum 30-50 students per batch',
  },
  {
    icon: Award,
    title: 'Industry Certification',
    description: 'Get certified with recognized SAP S4HANA certifications',
  },
  {
    icon: Clock,
    title: 'Flexible Timing',
    description: 'Early morning batches available for working professionals',
  },
];

const FeaturesSection: React.FC = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Why Choose ShreeGuruCool Technologies?
        </h2>
        <p className="text-xl text-gray-600">
          We provide comprehensive SAP S4HANA training with industry-best practices
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="text-center group">
            <div className="bg-blue-50 rounded-full p-6 w-20 h-20 flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-100 transition-colors">
              <feature.icon className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
